import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthenticatedTemplate } from "@azure/msal-react";
import AccessDenied from "./AccessDenied";

export default function ProtectedRoutes({ children, msalInstance }) {
  console.log(msalInstance.getActiveAccount()?.idTokenClaims?.roles);
  if (
    msalInstance.getActiveAccount()?.idTokenClaims?.roles?.includes("user") ||
    msalInstance.getActiveAccount()?.idTokenClaims?.roles?.includes("admin")
  ) {
    console.log("Access Granted! ");
    return children;
  }
  console.log("Access Denied! ");
  return (
    <AuthenticatedTemplate>
      <Routes>
        <Route path="*" element={<AccessDenied />} />
      </Routes>
    </AuthenticatedTemplate>
  );
}
